module.exports = __webpack_public_path__ + "img/2_146.aaf1d377.png";